//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import HeaderMain from './components/Header.vue'
  import mainForm from './components/Main.vue'
  import footerMain from './components/Footer.vue'
  import preloader from './components/controls/Preloader.vue'
export default {
  name: 'App',
    components:{
        HeaderMain,
        mainForm,
        footerMain,
        preloader,
    },
    created() {
        const readyHandler = () => {
            if (document.readyState == 'complete') {

                setTimeout(()=>{
                    this.loading = false;
                },200);
                document.removeEventListener('readystatechange', readyHandler);
            }
        };

        document.addEventListener('readystatechange', readyHandler);

        readyHandler();
    },
  data: () => ({
      loading: true
  }),
};
